var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget contact-properties" }, [
    _c(
      "div",
      { staticClass: "widget-content", style: _vm.gridStyle },
      [
        _vm._l(_vm.visibleProperties, function (element, index) {
          return _c(
            "div",
            {
              key: element._id,
              staticClass: "drag-row",
              style: { gridColumn: "span 1" },
            },
            [
              _c("ContactDetailItem", {
                attrs: {
                  contact: _vm.contact,
                  label: _vm.getLabel(element),
                  value: _vm.getPropertyValue(element._id),
                  inputType: element.type,
                  options: element.options || [],
                  orderable: false,
                  draggable: false,
                },
                on: {
                  edit: function ($event) {
                    return _vm.updatePropertyValue(element._id, $event)
                  },
                  add: function ($event) {
                    return _vm.addPropertyValue(element._id, $event)
                  },
                  delete: function ($event) {
                    return _vm.deleteProperty(element._id)
                  },
                },
              }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.sortedContactProperties.length === 0
          ? _c("div", [_vm._v(_vm._s(_vm.$t("message.noPropertiesAdded")))])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }